import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import type { RootState } from 'reduxStore/reducers';
import { requestServiceSalesReportDataAction } from '../actions';
import { ServiceSalesReport } from './index';

const mapStateToProps = (state: RootState) => ({
  reportData: state.salesReport.serviceSales.reportData,
  displayState: state.salesReport.serviceSales.displayState,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  ...bindActionCreators({ requestServiceSalesReportDataAction }, dispatch),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(ServiceSalesReport);
